import { useCallback, useEffect, useRef } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { deselectIfAlreadySelected, sanitizeValue } from '../utils/campaignSelect';
export default function useGetCampaignSelectChangeHandler({
  initialOptions = [],
  multi,
  onChange
}) {
  // Keep a ref to the initial options to merge them
  // together when creating a new campaign with multi=true
  const currentOptionsRef = useRef(initialOptions);
  useEffect(() => {
    currentOptionsRef.current = initialOptions;
  }, [initialOptions]);
  return useCallback(optionOrOptions => {
    const isArray = Array.isArray(optionOrOptions);
    if (!optionOrOptions || isArray && optionOrOptions.length === 0) {
      return onChange(syntheticEvent([]), [], undefined);
    }
    if (multi) {
      // if multi=true, we force to call onChange with an array
      let options = [];
      if (!isArray) {
        // if we are passed a single item when multi=true, we need to handle
        // the current options reference
        options = currentOptionsRef.current.concat(optionOrOptions);
        currentOptionsRef.current = options;
      } else {
        // otherwise we just use the options passed
        options = deselectIfAlreadySelected(optionOrOptions);
      }
      const sanitizedOptions = options.map(option => sanitizeValue(option.value));
      return onChange(syntheticEvent(sanitizedOptions), options, options.slice(-1)[0]);
    }

    // if not multi, we force to call onChange with a single item
    const option = isArray ? optionOrOptions[0] : optionOrOptions;
    return onChange(syntheticEvent(sanitizeValue(option.value)), [option], option);
  }, [multi, onChange]);
}